<div class="w-100 float-left v-align relative" (click)="clicked()">
    <!-- <h5 class="medium float-left"> Employees </h5> -->
    <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
        <h5 class="medium m-0">{{'OrgUnits' | translate}}</h5>
        <div style="flex-grow: 1;"></div>
        <button class="btn btn-primary float-right mr-3" (click)="orgAdd()"> {{'addOrg' | translate}}</button>
        <!-- <button class="btn btn-secondary float-right" (click)="empActions(!hide)"> Action </button> -->
    </div>
</div>
<div class="w-100 float-left text-13x">
    <div class="w-100 float-left" *ngFor="let org of orgData">
        <org [org]='org' (deleteOrgEvent)="removeFromChild($event)" (editOrgEvent)="editOrg($event)"
             (refresh)="refreshLocal($event)"></org>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/tools/org/organizationList.html